// Reusable in-page tab bar for geo pages (Country / State / City).
export default function SectionTabs({ tabs, active, onChange, testid }) {
  return (
    <div className="flex flex-wrap gap-1 border-b border-zinc-200" data-testid={testid}>
      {tabs.map((t) => (
        <button key={t.id} onClick={() => onChange(t.id)} data-testid={`${testid}-${t.id}`}
          className={`inline-flex items-center gap-1.5 px-4 py-2.5 text-sm font-600 border-b-2 -mb-px transition-colors ${active === t.id ? "border-primary text-primary" : "border-transparent text-muted-foreground hover:text-foreground"}`}>
          <t.icon className="w-4 h-4" /> {t.label}
        </button>
      ))}
    </div>
  );
}
